/**
 * WebSocket helper — opens a connection to the GoobDoob VTT API Gateway
 * WebSocket API with the caller's Cognito ID token attached as ?token=.
 * The API Gateway Cognito authorizer validates the token on $connect
 * before the upgrade completes, so an invalid/expired token fails fast
 * with a 401 during the handshake.
 *
 * Usage:
 *   const ws = await openSocket();
 *   ws.addEventListener('message', ...);
 */
import { getIdToken } from './auth';

const BaseUrl = import.meta.env.VITE_WS_URL as string;

export async function openSocket(): Promise<WebSocket> {
  if (!BaseUrl) {
    throw new Error('VITE_WS_URL is not configured');
  }
  const token = await getIdToken();
  if (!token) {
    throw new Error('Not authenticated — cannot open WebSocket');
  }
  const url = `${BaseUrl}?token=${encodeURIComponent(token)}`;
  return new WebSocket(url);
}
